const types = {
  internalqueue: 'queue',
  blind_agent: 'agent',
  assisted_agent: 'agent',
  blind_number: 'number',
  assisted_number: 'number',
};

export default {
  types,
  getTypeString(type: string | null) {
    if (typeof types[type as any] !== 'undefined') {
      return `Transfer to ${types[type as any]}`;
    }
    return 'Transfer';
  },
};
